<template>
  <div>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->

    <b-row>
      <b-col cols="12">
        <b-overlay :show="isLoading" rounded="sm">
          <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-brand href="#">
                <strong style="color:#3b3e66">Gifts & Hospitality Request Approvals</strong>
              </b-navbar-brand>

              <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button variant="outline-info" size="sm" class="mr-3" @click="reloadTable">
                      <font-awesome-icon icon="sync" />
                    </b-button>
                    <b-form-group>
                      <b-input-group size="sm">
                        <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
            <b-table
              sticky-header="calc(100vh - 295px)"
              :busy.sync="isLoading"
              ref="table"
              id="my-table"
              :fields="staticFields"
              :items="getApprovalsData"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              style="background-color:#fff;"
            >
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(requested_by)="data">
                <p>{{data.item.requested_by_first_name+' '+data.item.requested_by_last_name}}</p>
              </template>
              <template v-slot:cell(title)="data">
                <p
                  class="link-text"
                  @click="OpenDetailPage('/gifts-approval/'+data.item.id+'/1')"
                >{{data.item.title}}</p>
              </template>
              <template v-slot:cell(approvers_name_list)="data">
                <div>
                  <b-avatar-group>
                    <b-avatar
                      v-for="(approver, approversIndex) in data.item.approval_approvers"
                      :key="approversIndex"
                      variant="dark"
                      v-b-tooltip.hover.bottom="approver.first_name+' '+approver.last_name"
                    >{{getApproverName(approver)}}</b-avatar>
                  </b-avatar-group>
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <b-badge v-if="data.item.status == 1" variant="info">OPEN</b-badge>
                <b-badge v-else-if="data.item.status == 2" variant="warning">COMPLETED</b-badge>
                <b-badge v-else-if="data.item.status == 3" variant="danger">ON-HOLD</b-badge>
                <b-badge v-else-if="data.item.status == 4" variant="success">APPROVED</b-badge>
                <b-badge v-else-if="data.item.status == 5" variant="danger">REJECTED</b-badge>
              </template>
              <template v-slot:cell(progress)="data">
                <span>{{getCountOfApprovers(data.item.approval_approvers)}}/{{data.item.approval_approvers.length}}</span>
                <span>
                  <b-progress
                    :value="getCountOfApprovers(data.item.approval_approvers)"
                    :max="data.item.approval_approvers.length"
                    variant="success"
                  ></b-progress>
                </span>
              </template>
            </b-table>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Displaying Results From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "EmployeeApprovalList",
  data() {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Gifts",
          href: "#",
          active: true,
        },
      ],
      isLoading: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      fromRows: 0,
      toRows: 0,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        {
          key: "created_at",
          label: "Date Filed",
          sortable: true,
        },
        {
          key: "title",
          label: "Approval",
          sortable: true,
        },
        // {
        //     key: "currency",
        //     label: "Currency",
        //     sortable: false,

        // },
        {
          key: "amount",
          label: "Amount (USD)",
          sortable: true,
        },
        {
          key: "requested_by",
          label: "Requested By",
          sortable: true,
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
        },
        {
          key: "department",
          label: "Department",
          sortable: true,
        },
        {
          key: "progress",
          label: "Progress",
          sortable: false,
        },
        {
          key: "approvers_name_list",
          label: "Approvers",
          sortable: false,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  methods: {
    OpenDetailPage(url) {
      this.$router.push(url);
    },
    getApproverName(data) {
      let firstName = data.first_name.toUpperCase();
      let lastName = data.last_name.toUpperCase();
      let name = firstName.charAt(0) + lastName.charAt(0);

      return name;
    },
    getCountOfApprovers(data) {
      let approvedApproversCount = [];
      data.map((approversData) => {
        if (approversData.status == 1) {
          approvedApproversCount.push(approversData);
        }
      });
      return approvedApproversCount.length;
    },
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    async getApprovalsData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let response = await HTTP(
        "post",
        "api/v1/approvals/get/all/list",
        formData
      );
      try {
        this.isLoading = false;
        this.totalRows = response.data.total;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        return response.data.data;
      } catch (err) {
        this.isLoading = false;
        return [err];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/table.css"; */
.fixed-bottom {
  right: auto !important;
  left: auto !important;
  width: 100%;
}
.card-body {
  padding: 0px;
}
.link-text {
  color: rgb(0 123 255);
  text-decoration: none;
  background-color: rgb(0 0 0 / 0%);
  cursor: pointer;
}
.link-text:hover {
  color: rgb(0 86 179);
  text-decoration: underline;
}
</style>
